export enum MyChartControlItems {
  PAST_HISTORY = 'PH',
  CURRENT_MEDICINES = 'CM',
  ALLERGIES = 'AL',
  PAST_HISTORY_HOSPITAL_VISIBILITY = 'PAST_HISTORY_HOSPITAL_VISIBILITY',
  ALLERGIES_HOSPITAL_VISIBILITY = 'ALLERGIES_HOSPITAL_VISIBILITY',
  MEDICINES_HOSPITAL_VISIBILITY = 'MEDICINES_HOSPITAL_VISIBILITY'
}
